/**
 * @generated SignedSource<<a837816c1c68320c92238df69b681747>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_AllProductsForUnassignQuery$variables = Record<PropertyKey, never>;
export type productSidePanelContent_AllProductsForUnassignQuery$data = {
  readonly modelsHierarchy: ReadonlyArray<{
    readonly productID: string;
  }>;
};
export type productSidePanelContent_AllProductsForUnassignQuery = {
  response: productSidePanelContent_AllProductsForUnassignQuery$data;
  variables: productSidePanelContent_AllProductsForUnassignQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductHierarchy",
    "kind": "LinkedField",
    "name": "modelsHierarchy",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_AllProductsForUnassignQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "productSidePanelContent_AllProductsForUnassignQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "615dfac4fc5f9d8f1d4ccaaf13eb427e",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_AllProductsForUnassignQuery",
    "operationKind": "query",
    "text": "query productSidePanelContent_AllProductsForUnassignQuery {\n  modelsHierarchy {\n    productID\n  }\n}\n"
  }
};
})();

(node as any).hash = "ec6817078da09d0db7553888b3ae038c";

export default node;
